import { render, staticRenderFns } from "./AdminCommerciale.vue?vue&type=template&id=21b4ac41&scoped=true&"
import script from "./AdminCommerciale.vue?vue&type=script&lang=js&"
export * from "./AdminCommerciale.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommerciale.vue?vue&type=style&index=0&id=21b4ac41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b4ac41",
  null
  
)

export default component.exports